import { render, staticRenderFns } from "./nutritionLibrary.vue?vue&type=template&id=c6f8089e&scoped=true"
import script from "./nutritionLibrary.vue?vue&type=script&lang=js"
export * from "./nutritionLibrary.vue?vue&type=script&lang=js"
import style0 from "./nutritionLibrary.vue?vue&type=style&index=0&id=c6f8089e&prod&lang=scss&scoped=true"
import style1 from "./nutritionLibrary.vue?vue&type=style&index=1&id=c6f8089e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f8089e",
  null
  
)

export default component.exports